// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"CustomDialog_dialogContent__1eddQ"};